import { gql } from "@apollo/client";

export const GET_PRODUCT = gql`
  query Product($productId: Int!) {
    product(id: $productId) {
      id
      store {
        id
        title
        closingHours
        address
      }
      name
      price
      discountPrice
      userPrice
      quantity
      currentCount
      description
      saleEndTime
      createdAt
      updatedAt
      img
      isEnd
      menus {
        id
        img
        quantity
        menu {
          name
          price
          description
        }
      }
      isSampleMenu
    }
  }
`;
